export class NavbarButtonResetMessage {
    public targetId = 'all';
    
    constructor(target: string) {
        this.targetId = target;
    }
}
